import { ApplicationContext, AuthenticatedApplicationContext } from './contextModel';

export function isAuthenticatedContext(
    context: ApplicationContext
): context is AuthenticatedApplicationContext {
    return context.principal !== null;
}
